import { Button } from "../../../components/ui/button";

interface DateRangeToggleProps {
  value: "today" | "week";
  onChange: (value: "today" | "week") => void;
}

export function DateRangeToggle({ value, onChange }: DateRangeToggleProps) {
  return (
    <div className="flex items-center rounded-lg border border-border bg-muted p-1">
      <Button
        variant={value === "today" ? "default" : "ghost"}
        size="sm"
        onClick={() => onChange("today")}
        className="px-3 text-xs font-medium"
        data-testid="button-today"
      >
        Hôm nay
      </Button>
      <Button
        variant={value === "week" ? "default" : "ghost"}
        size="sm"
        onClick={() => onChange("week")}
        className="px-3 text-xs font-medium"
        data-testid="button-week"
      >
        Tuần này
      </Button>
    </div>
  );
}
